module.exports = {"id":"dp5_1l3q5","text":"Problem-solving approaches","instructions":"Which approach supports resolving unfamiliar technical issues?","multiselect":false,"category":"5.1","questionType":"PickOne","random":true,"options":[{"id":"dp5_1l3q5-a1","text":"Testing solutions systematically","score":3.7},{"id":"dp5_1l3q5-a2","text":"Randomly changing settings","score":1.3},{"id":"dp5_1l3q5-a3","text":"Avoiding further investigation","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.1/l3q5.json
// module id = 1290
// module chunks = 41